<div class="data-table-container">
  <table class="fieldgroup-table">
    <thead>
      <tr>
        <th class="row-number-col">#</th>
        <th *ngFor="let col of columns">
          <span [class.mandatory-field]="col.required">{{ col.label }}</span>
          <lib-popover
            style="vertical-align: text-bottom"
            *ngIf="col.helpText"
            popoverType="info"
            popoverSize="medium"
            popoverPlacement="right">
            <app-description-text
              [description]="col.helpText"
              [parseAsMarkdown]="showHyperlinkInDescription"
              [checkFromIllumina]="true">
            </app-description-text>
          </lib-popover>
        </th>
        <th class="actions-col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rowFormGroups; let i = index" [formGroup]="row">
        <td class="row-number-cell">{{ i + 1 }}</td>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">

            <!-- Textbox -->
            <ng-container *ngSwitchCase="'textbox'">
              <lib-form-field [label]=""
                              [isValidateOnTouch]="true"
                              [errorMessage]="getErrorMessage(row, col)">
                <input lib-input
                       [formControlName]="col.id"
                       type="text"
                       data-cy="fieldgroup-textbox">
              </lib-form-field>
            </ng-container>

            <!-- Number -->
            <ng-container *ngSwitchCase="'number'">
              <lib-form-field [label]=""
                              [isValidateOnTouch]="true"
                              [errorMessage]="getErrorMessage(row, col)">
                <input lib-input
                       [formControlName]="col.id"
                       type="number"
                       data-cy="fieldgroup-number">
              </lib-form-field>
            </ng-container>

            <!-- Integer -->
            <ng-container *ngSwitchCase="'integer'">
              <lib-form-field [label]=""
                              [isValidateOnTouch]="true"
                              [errorMessage]="getErrorMessage(row, col)">
                <input lib-input
                       [formControlName]="col.id"
                       type="number"
                       data-cy="fieldgroup-integer">
              </lib-form-field>
            </ng-container>

            <!-- Select -->
            <ng-container *ngSwitchCase="'select'">
              <combobox placeholder="Select"
                        [formControlName]="col.id"
                        [label]="col.label"
                        [enableDeleteBtn]="true"
                        data-cy="fieldgroup-select">
                <combobox-option *ngFor="let option of filterChoices(col.choices)"
                                 [value]="option.value"
                                 [label]="option.text">
                </combobox-option>
              </combobox>
            </ng-container>

            <!-- Checkbox -->
            <ng-container *ngSwitchCase="'checkbox'">
              <lib-radio-checkbox
                [disabled]="row.controls[col.id].disabled"
                [checked]="row.controls[col.id].value"
                (change)="onCheckBoxChange($event, row, col.id)"
                data-cy="fieldgroup-checkbox">
              </lib-radio-checkbox>
              <span class="error-message">{{ getErrorMessage(row, col) }}</span>
            </ng-container>

            <!-- Radio -->
            <ng-container *ngSwitchCase="'radio'">
              <lib-radio-checkbox-group type="radio"
                                        [required]="col.required"
                                        [name]="col.id + '_' + i"
                                        [formControlName]="col.id"
                                        [options]="col.choices"
                                        valueProperty="value"
                                        labelProperty="text"
                                        data-cy="fieldgroup-radio">
              </lib-radio-checkbox-group>
              <span class="error-message">{{ getErrorMessage(row, col) }}</span>
            </ng-container>

            <!-- File Select -->
            <ng-container *ngSwitchCase="'fileSelect'">
              <app-file-select-dropdown
                [parentFormGroup]="row"
                [formField]="col"
                [supportLocalUpload]="analysisLocation === 'Local'"
                [supportUnselect]="!col.required"
                [analysisVersionDefinitionId]="analysisVersionDefinitionId"
                data-cy="fieldgroup-file-select">
              </app-file-select-dropdown>
            </ng-container>

            <!-- Genome -->
            <ng-container *ngSwitchCase="'genome'">
              <app-genome-dropdown
                [genomeFormControlName]="col.id"
                [fieldLabel]="col.label"
                [showHyperlinkInDescription]="showHyperlinkInDescription"
                [analysisVersionDefinitionId]="analysisVersionDefinitionId"
                [settings]="col.settings"
                data-cy="fieldgroup-genome">
              </app-genome-dropdown>
            </ng-container>

            <!-- Reference File -->
            <ng-container *ngSwitchCase="'referenceFile'">
              <app-reference-file-dropdown
                [referenceFileFormControlName]="col.id"
                [referenceFileFieldSettings]="col.settings"
                [referenceFileGenomeFilterFieldId]="(col.settings && col.settings.referenceFileGenomeFilterFieldId) || null"
                [genomeFilterGenomeId]="col.genomeFilterGenomeId"
                [referenceFileTypeFilter]="(col.settings && col.settings.referenceFileTypeFilter) || null"
                [genomeHashTableVersion]="col.settings && col.settings.referenceFileGenomeHashTableVersion"
                [analysisVersionDefinitionId]="analysisVersionDefinitionId"
                [isRequired]="col.required"
                [fieldLabel]="col.label"
                [disableReferenceFileUpload]="false"
                [newReferenceFileName$]="referenceFileRefresh$"
                data-cy="fieldgroup-reference-file">
              </app-reference-file-dropdown>
            </ng-container>

          </ng-container>
        </td>
        <td class="row-actions-cell">
          <rad-icon-button
            (click)="removeRow(i)"
            class="rad-theme--light"
            icon-name="close"
            title="Remove row"
            [attr.disabled]="disabled || isMinRowsReached() || null"
            style="padding: 6px;">
          </rad-icon-button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<span *ngIf="minRows > 0 && isMinRowsReached()" class="constraint-message">
  At least {{ minRows }} row(s) required.
</span>
<span *ngIf="isMaxRowsReached()" class="constraint-message">
  Maximum of {{ maxRows }} row(s) reached.
</span>

<rad-button
  class="rad-theme--light"
  (click)="addRow()"
  [attr.disabled]="disabled || isMaxRowsReached() || null"
  variant="secondary"
  [attr.icon-name-before]="'plus'">
  Add row
</rad-button>
